import React, { FC } from 'react';
import { BodyText, Link, PrimaryButton } from '@minecraft.atoms';
import { Trans, useTranslation } from '@blocs.i18n';
import { HEADSHOTS_MODAL_ACTION_PROPS, HeadshotsModalLayout } from './HeadshotsModalLayout';

export type HeadshotsBookedModalProps = {
  /** Booked session, formatted as "Tuesday, August 25 at 10:00 AM". */
  sessionDateTime: string;
  onClose: () => void;
};

/**
 * "You're All Set" modal for a talent with an upcoming headshot session.
 * Copy only — eligibility and formatting live in `useHeadshotBookedModal`.
 */
export const HeadshotsBookedModal: FC<HeadshotsBookedModalProps> = ({ sessionDateTime, onClose }) => {
  const { t } = useTranslation();

  return (
    <HeadshotsModalLayout
      title={t('talent:headshots.bookedModal.title')}
      summary={
        <>
          <BodyText fontWeight="semibold">{sessionDateTime}</BodyText>
          <BodyText>{t('talent:headshots.bookedModal.body')}</BodyText>
        </>
      }
      details={
        <BodyText>
          <Trans
            i18nKey="talent:headshots.bookedModal.questions"
            components={{ emailLink: <Link to="mailto:headshots@castingnetworks.com" /> }}
          />
        </BodyText>
      }
      actions={
        <PrimaryButton
          {...HEADSHOTS_MODAL_ACTION_PROPS}
          label={t('talent:headshots.bookedModal.gotIt')}
          onClick={onClose}
        />
      }
      closeLabel={t('common:button.close')}
      onClose={onClose}
    />
  );
};

export default HeadshotsBookedModal;
